import React, { useEffect, useState } from 'react';
import PropType from 'prop-types';
import { getHistoryRemission } from '../../../../services/getHistoryRemission';
import moment from 'moment/moment';

export const TableRemissionHistory = ({ id_document }) => {
  const [history, setHistory] = useState(null);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const getHistory = async () => {
      setLoad(true);
      const { history = [] } = await getHistoryRemission(id_document);
      setLoad(false);
      if (history.length === 0) {
        setHistory(null);
      } else {
        setHistory(history);
      }
    };
    getHistory();
  }, [id_document]);

  if (load) {
    return <div className={'text-center'}>Cargando historial de remisiones...</div>;
  }

  if (!history) {
    return <div className={'text-center'}>No hay historial de remisiones</div>;
  }

  return (
    <div>
      <h5 className={'text-center'}>Historial de remisiones</h5>

      <table className="table table-collapsed table-bordered mT-10" style={{ maxHeight: '10px' }}>
        <thead>
          <tr className="table-documents-modal">
            <th className="text-center">Acción</th>
            <th className="text-center">Fecha</th>
          </tr>
        </thead>

        <tbody>
          {history.map((item, index) => (
            <tr key={index}>
              <td className="text-center">{item.status ? 'Remitir' : 'Cancelar remisión'}</td>
              <td className="text-center">{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TableRemissionHistory.propTypes = {
  id_document: PropType.number.isRequired,
};
